import moment from "moment";
import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch } from "react-redux";
import { getVideoforChapter } from "../../../features/slices/courseDetails";
import { useSelector } from "react-redux";
const CourseContentSideBar = ({ res, handleVideo }) => {
  const dispatch = useDispatch();
  const { video } = useSelector((state) => {
    return state.courseDetails;
  });

  const [activeVideoId, setActiveVideoId] = useState(null);
  const [visibleChapters, setVisibleChapters] = useState(5);

  const handleCourseVideo = (id) => {
    dispatch(getVideoforChapter({ chapterId: id }));
  };

  const handleVideoPlay = (data, id) => {
    handleVideo(data);
    setActiveVideoId(id);
  };
  const loadMoreChapters = () => {
    setVisibleChapters((prev) => prev + 5);
  };
  return (
    <>
      <div className="col-lg-4">
        <div className="Small-Wrapper">
          <div className="TitleBox Border flex-column align-items-start">
            <h4 className="Title">Course Content</h4>
            <p>
              Lecture ({res?.totalVideos}) Total (
              {moment.utc(res?.duration * 1000).format("HH:mm:ss")}Hrs)
            </p>
          </div>
          <div className="CourseContent">
            <div className="StaticArea">
              <div id="accordion">
                {res?.chapterData?.slice(0, visibleChapters).map((data, i) => {
                  const headingId = `heading${i}`;
                  const collapseId = `collapse${i}`;

                  return (
                    <div className="card" key={data?._id}>
                      <div className="card-header" id={headingId}>
                        <h5
                          className="mb-0"
                          style={{
                            width: "100%",
                          }}
                        >
                          <button
                            className="btn btn-link btn-block text-left"
                            type="button"
                            data-toggle="collapse"
                            data-target={`#${collapseId}`}
                            aria-expanded="false"
                            aria-controls={collapseId}
                            onClick={() => handleCourseVideo(data?._id)}
                            style={{
                              color: "black",
                              fontWeight: "400",
                              textDecoration: "none",
                            }}
                          >
                            <strong style={{ marginRight: "5px" }}>
                              {i + 1}
                            </strong>{" "}
                            {data?.chapterName}
                          </button>
                        </h5>
                        <p>
                          <span className="Play">
                            <i className="fa-solid fa-play" />
                          </span>{" "}
                          {data?.totalVideos} Video |{" "}
                          {moment
                            .utc(data?.totalDuration * 1000)
                            .format("HH:mm:ss")}{" "}
                          Hrs
                        </p>
                      </div>

                      <div
                        id={collapseId}
                        className="collapse"
                        aria-labelledby={headingId}
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <div className="SectionBody">
                            <ul>
                              {video?.result?.map((videoData) => (
                                <li
                                  key={videoData?._id}
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor:
                                      videoData?._id === activeVideoId
                                        ? "#f0f0f0"
                                        : "transparent",
                                  }}
                                  onClick={() =>
                                    handleVideoPlay(
                                      videoData?.lessonMedia?.[0]?.video,
                                      videoData?._id
                                    )
                                  }
                                >
                                  <span className="Overlay Check">
                                    <i className="fa-solid fa-check" />
                                  </span>
                                  <h2>{videoData?.lectureName}</h2>
                                  <p>
                                    <span className="Play">
                                      <i className="fa-solid fa-play" />
                                    </span>{" "}
                                    1 Video |{" "}
                                    {moment
                                      .utc(
                                        videoData?.lessonMedia?.[0]?.duration *
                                          1000
                                      )
                                      .format("HH:mm:ss")}{" "}
                                    Hrs
                                  </p>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {res?.chapterData?.length > visibleChapters ? (
            <a
              href="javascript:void(0);"
              className="LoadMoreCourse"
              onClick={loadMoreChapters}
            >
              Load more Chapters
            </a>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default CourseContentSideBar;
